import React from 'react';
import { observer, inject } from 'mobx-react';
import { Panel, Row, Col, Button } from 'react-bootstrap';
import UserList from './UserList';
import AddUser from './AddUser';

@inject('userStore')
@observer
export default class Users extends React.Component {

    render() {
        return (<Panel>
            <Panel.Heading>
                   <Row>
                       <Col lg={10} > <h5>Onboarded Users</h5> </Col>
                       <Col lg={2} ><Button bsStyle="primary" onClick={()=>{this.props.userStore.ShowOrHideAddUserModal();}} >Add User</Button></Col>
                   </Row>
            </Panel.Heading>
            <Panel.Body>
                <UserList />
                <AddUser />
            </Panel.Body>
        </Panel>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/index.js